import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { message } from "antd";
import { getResolvedApiBaseUrl } from "../utils/domainConfig";
// import { toast } from "react-toastify";

export const dynamicBaseQuery = async (args, WebApi, extraOptions) => {
  const baseUrl = getResolvedApiBaseUrl(import.meta.env.VITE_API_BASE_URL || "http://192.168.31.231:3001/");
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: baseUrl,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  const result = await rawBaseQuery(args, WebApi, extraOptions);
  if (result?.error) {
    const responseMessage = result?.error?.data?.error || result?.error?.data?.message;
    const status = result?.error?.status;
    if (status === 401) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      console.log('Error message from server:', responseMessage);
      message.error(responseMessage);
    }
  }
  // If we have a data payload, prefer showing its `message` when present.
  if (result?.data) {
    const res = result.data;
    const msg = res?.message || res?.msg || null;
    const successFlag = res?.success ?? res?.status ?? null;

    if (msg) {
      // Determine whether to show success or error depending on common flag shapes
      if (successFlag === false || successFlag === 0) {
        message.error(msg);
      } else {
        // treat missing/true/positive values as success
        message.success(msg);
      }
    }
  }
  return result;
};
